import dynamic from "next/dynamic";
import type { FeatureFlags } from "@lib/feature-flags/types";

// Dynamically imported to keep vwo-smartcode-nextjs out of the shared JS bundle.
// next/dynamic with ssr:true (default) preserves server-side rendering of the script tag
// (required for VWO anti-flicker) while code-splitting the client JS.
const ABTestingScript = dynamic(() =>
    import("@lib/analytics/ABTesting").then((mod) => mod.ABTestingScript)
);

/**
 * some scripts needs to be in the head of the document, for example the VWO script for A/B testing. This component is used to render those scripts in the head.
 * We separate this from the GlobalScripts because some scripts needs to be rendered in the body and some in the head, and we want to avoid rendering scripts that are not needed in the head.
 * The feature flags are passed down from the layout, so we can control which scripts are rendered in the head based on the feature flags.
 * We want to keep this component as simple as possible, so we only render the scripts that are needed in the head and avoid any unnecessary logic or components here.
 */
const HeadScripts = ({ featureFlags }: { featureFlags: FeatureFlags }) => {
    const { isVwoEnabled } = featureFlags ?? {};

    return <>{isVwoEnabled?.enabled && <ABTestingScript />}</>;
};

export default HeadScripts;
